<template>
  <div id="CORegistRequest">
    <section>
      <div id="container-center">
        <h1
          style=""
          class="title has-text-centered"
        >ケア オーケストレーター 利用申込み</h1>
        <div>
          <b-steps
            v-model="activeStep"
            :animated="true"
            :rounded="true"
            :has-navigation="false"
            label-position="bottom"
          >
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline">
              <div id="item-contens">
                <div class="request-title">
                  <b-button v-if="isDealer()" class="is-primary" style="float:left;" @click.prevent="goHome">戻る</b-button>
                  <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面</b-button>
                  <b-button class="is-primary" style="float: right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約に同意のうえ、申込みを行ってください。</span>
                </div>
                <div class="card-content margin-top">
                  <div>
                    <span style="font-size:20px;">利用規約</span>
                    <a @click="download"><b-icon style="margin-top:3px;" icon="file-download-outline"/></a>
                  </div>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreementStr"/></td></tr>
                    <tr><td><div  style="text-align: center;">
                            <b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox>
                            </div>
                        </td>
                    </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="施設情報" icon="hospital-building">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                  <span>施設情報の内容を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>医療機関名<span class="require"/></th><td><input type="text" maxlength="100" v-model="institutionApplication.hospitalName" class="2" name="医療機関名" validate="required"/></td></tr>
                    <tr><th>診療科<span class="require"/></th><td><input type="text" maxlength="100" v-model="institutionApplication.division" class="2" name="診療科" validate="required"/></td></tr>
                    <tr v-if="isDealer()"><th>担当支店<span class="require"/></th>
                      <td>
                        <select v-model="institutionApplication.office" class="2" name="担当支店" validate="required">
                          <option v-for="branch in branchList" :value="branch.code" :key="branch.code">{{ branch.name }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="isDealer()"><th></th><td>※医療機関を担当するPhilipsの支店を選択してください。ご不明の場合はPhilips営業担当者にご連絡ください。</td></tr>
                    <tr>
                      <th>
                        郵便番号<span class="require"/>
                      </th>
                      <td>
                        <input
                          type="text"
                          v-model="institutionApplication.zip"
                          maxlength="7"
                          class="2"
                          :class="{'border-red': invalidPostcode}"
                          name="郵便番号"
                          validate="required|numeric"
                          :placeholder="postcodePlaceholder"
                        />
                        <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>都道府県<span class="require"/></th><td><input type="text" v-model="institutionApplication.prefecture" maxlength="20" class="2" name="都道府県" validate="required"/></td></tr>
                    <tr><th>市町村<span class="require"/></th><td><input type="text" v-model="institutionApplication.city" maxlength="100" class="2" name="市町村" validate="required"/></td></tr>
                    <tr><th>住所1<span class="require"/></th><td><input type="text" v-model="institutionApplication.address1" maxlength="100" class="2" name="住所1" validate="required"/></td></tr>
                    <tr><th>住所2</th><td><input type="text" v-model="institutionApplication.address2" maxlength="100"/></td></tr>
                    <tr>
                      <th>
                        電話番号<span class="require"/>
                      </th>
                      <td>
                        <input
                          type="text"
                          v-model="institutionApplication.phoneNumber"
                          maxlength="11"
                          class="2"
                          :class="{'border-red': invalidPhoneNumber}"
                          name="電話番号"
                          validate="required|numeric"
                          :placeholder="phonePlaceholder"
                        />
                        <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                      </td>
                    </tr>
                    <tr><th>クライアント認証<span class="require"/></th>
                        <td>
                          <div class="block">
                            <b-radio class="td_radio" name="clientAuth" v-model="institutionApplication.clientAuthentication" :native-value="true">有効にする</b-radio>
                            <b-radio class="td_radio" name="clientAuth" v-model="institutionApplication.clientAuthentication" :native-value="false">有効にしない</b-radio>
                          </div>
                        </td>
                    </tr>
                    <tr><th></th>
                      <td>
                        <span class="urgency_caution" style="margin-left:0px;">※医療情報システムの安全管理に関するガイドライン（厚生労働省）では、医療機関等に向けて「不特定の端末から接続されるリスクがある場合、TLS クライアント認証を行うこと」が求められています。</span><br/>
                        ※クライアント認証機能を有効にした場合、Philipsが発行する証明書をインストールした端末からのみCOにアクセスできます。
                      </td>
                    </tr>
                    <template v-if="isDealer()">
                      <tr><th>フィリップス保守サービス<span class="require" /></th><td>
                        <div class="block">
                          <b-radio class="td_radio" name="crossReference" v-model="institutionApplication.crossReference" :native-value="true">有</b-radio>
                          <b-radio class="td_radio" name="crossReference" v-model="institutionApplication.crossReference" :native-value="false">無</b-radio>
                        </div></td>
                      </tr>
                      <tr><th></th><td>※「無」を選択した場合、フィリップス・ジャパンによる保守は受けられません。</td></tr>
                    </template>
                    <tr><th>備考</th><td><textarea v-model="institutionApplication.biko" maxlength="256" style="resize:vertical;max-width:100%;"/></td></tr>
                    <tr v-if="isDealer()">
                      <td colspan="2"><div  style="text-align: center;">
                            <b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者がケア オーケストレーターの申込みを行うことについて、該当医療機関の同意を取得しています。</b-checkbox>
                            </div>
                        </td>
                    </tr>
                  </table>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>■情報の管理に関する事項</th><td></td></tr>
                    <tr><td colspan="2" style="padding-left:20px;">申請者は、上記の情報がケア　オーケストレーター上で管理されることに同意します。<br>株式会社フィリップス・ジャパンは、当申請書より知り得た情報を、ケア　オーケストレーターに関わる運用保守業務以外に使用しません。</td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" :label="isDealer() ? 'ユーザー情報（医療施設）' : 'ユーザー情報'" icon="account-multiple">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                  <span v-if="isDealer()">ユーザーの情報（医療施設）を入力してください。</span>
                  <span v-else>ユーザーの情報を入力してください。</span>
                </div>
                <template v-for="(user, index) in userInfoList">
                  <div class="card-content margin-top" :key="index">
                    <table>
                      <tr v-if="index > 0">
                        <td colspan="2">
                          <b-button
                            style="float:right; width:27px; height:27px; border:none;"
                            icon-left="close-box-outline"
                            @click="deleteUser('userInfoList', index)"></b-button>
                        </td>
                      </tr>
                      <tr><th>姓<span class="require" /></th><td><input type="text" v-model="user.familyName" maxlength="100" class="3" :name="index+1+'番目ユーザー姓'" validate="required" placeholder="セキュリティ対策の為、必ず個人名を入力してください。個人を特定できない場合、申請を取消します。"/></td></tr>
                      <tr><th>名<span class="require" /></th><td><input type="text" v-model="user.firstName" maxlength="100" class="3" :name="index+1+'番目ユーザー名'" validate="required" placeholder="セキュリティ対策の為、必ず個人名を入力してください。個人を特定できない場合、申請を取消します。"/></td></tr>
                      <tr><th style="vertical-align:top;">処方設定<span class="require" /></th><td>
                        <div class="block">
                          <b-radio class="td_radio" :name="'prescriptionDealer' + index" v-model="user.prescriptionSettings" :native-value="true">操作可（少なくとも1ユーザーは操作可を指定してください）</b-radio>
                          <b-radio class="td_radio" :name="'prescriptionDealer' + index" v-model="user.prescriptionSettings" :native-value="false">操作不可</b-radio>
                        </div></td>
                      </tr>
                      <tr><th>希望ユーザーID</th><td></td></tr>
                      <tr><th>第一希望：<span class="require" /></th><td><input type="text" v-model="user.userIDFirstChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="3" :name="index+1+'番目ユーザーID:第一希望'" validate="required|userId" :id="index+'userId1'"/></td></tr>
                      <tr><th>第二希望：<span class="require" /></th><td><input type="text" v-model="user.userIDSecondChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="3" :name="index+1+'番目ユーザーID:第二希望'" validate="required|userId" :id="index+'userId2'"/></td></tr>
                      <tr><th>第三希望：<span class="require" /></th><td><input type="text" v-model="user.userIDThirdChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="3" :name="index+1+'番目ユーザーID:第三希望'" validate="required|userId" :id="index+'userId3'"/></td></tr>
                      <tr><th></th><td>※IDは6文字以上20文字以内。英文字・数字・記号のうち2種類を含めてください。大文字・小文字は区別しません。記号は”-”ハイフン又は”_”アンダースコアを使用してください。</td></tr>
                      <tr><th>メールアドレス<span class="require" /></th><td><input type="text" v-model="user.mail" class="3" :name="index+1+'番目ユーザーメールアドレス'" validate="required|mail"  maxlength="256"/></td></tr>
                      <tr><th></th><td>※ID登録完了、パスワードの再発行等はご登録いただいたメールアドレス宛てに、電子メールにてお知らせします。</td></tr>
                      <template v-if="!isDealer()">
                        <tr>
                          <th>ケア　エクスポーター<span class="require"/></th>
                          <td>
                              <div class="block">
                                <b-radio class="td_radio" :name="'careExporter' + index" v-model="user.careExporter" :native-value="true">利用する</b-radio>
                                <b-radio class="td_radio" :name="'careExporter' + index" v-model="user.careExporter" :native-value="false">利用しない</b-radio>
                              </div>
                            </td>
                        </tr>
                        <tr>
                          <th />
                          <td>
                            <!-- TODO: 関連資料を受け取ったらファイルを差し替える。 -->
                            ※治療レポートや患者一覧を一括出力することができるオプションツールです。詳細は担当営業にご確認ください。<br>
                            関連資料は<a class="under_line" :href="getUrlCatalog()" target="_blank" rel="noopener noreferrer">こちら</a>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                </template>
                <div class="margin-top">
                  <b-button style="width:100%;background:#6191eb; color:black;" @click="addUser('userInfoList')" >ユーザーを追加する</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                      <tr><th>■個人情報の管理に関する事項</th><td></td></tr>
                      <tr><td colspan="2" style="padding-left:20px;">
                            申請者は、上記の個人情報がケア　オーケストレーター上で管理されることに同意します。<br>
                            株式会社フィリップス・ジャパンは、当申請書より知り得た個人情報を、ケア　オーケストレーターに関わる運用保守業務以外に使用しません。<br>
                            ID・パスワード忘れに関するお問い合わせは、お電話での回答はできかねますのでご了承ください。<br>
                            異動などの事由により当ユーザーアカウントを使用されなくなった場合には、速やかに弊社営業担当者までお知らせ下さい。<br>
                            また、定期的にユーザーアカウントが使用されているか、確認させていただくことがございます。
                          </td>
                      </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item v-if="isDealer()" step="4" label="ユーザー情報（ディーラー）" icon="account-multiple">
              <div id="item-contens">
                <div class="dealer_request_title">
                  <b-button class="is-primary" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <div v-if="isDealer()" style="line-height: 1.2;">
                    ユーザーの情報（ディーラー）を入力してください。<br>
                    <span class="is-size-7 has-text-weight-bold">スキップする場合には、そのまま次へを押してください。</span>
                  </div>
                  <b-button class="is-primary" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <template v-for="(user, index) in userDealerInfoList">
                  <div class="card-content margin-top" :key="index">
                    <table>
                      <tr v-if="index > 0">
                        <td colspan="2">
                          <b-button
                            style="float:right; width:27px; height:27px; border:none;"
                            icon-left="close-box-outline"
                            @click="deleteUser('userDealerInfoList', index)"></b-button>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          姓<span class="require" />
                        </th>
                        <td>
                          <input type="text" v-model="user.familyName" maxlength="100" class="4" :name="index+1+'番目ユーザー姓'" validate="required" placeholder="セキュリティ対策の為、必ず個人名を入力してください。個人を特定できない場合、申請を取消します。"/>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          名<span class="require" />
                        </th>
                        <td>
                          <input type="text" v-model="user.firstName" maxlength="100" class="4" :name="index+1+'番目ユーザー名'" validate="required" placeholder="セキュリティ対策の為、必ず個人名を入力してください。個人を特定できない場合、申請を取消します。"/>
                        </td>
                      </tr>
                      <tr>
                        <th style="vertical-align:top;">
                          処方設定<span class="require" />
                        </th>
                        <td>
                          <div class="block">
                            <b-radio class="td_radio" :name="'prescriptionHealthCareWorker' + index" v-model="user.prescriptionSettings" :native-value="true">操作可</b-radio>
                            <b-radio class="td_radio" :name="'prescriptionHealthCareWorker' + index" v-model="user.prescriptionSettings" :native-value="false">操作不可</b-radio>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th colspan="2">希望ユーザーID</th>
                      </tr>
                      <tr>
                        <th>
                          第一希望：<span class="require" />
                        </th>
                        <td>
                          <input type="text" v-model="user.userIDFirstChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="4" :name="index+1+'番目ユーザーID:第一希望'" validate="required|userId" :id="index+'dealerUserId1'"/>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          第二希望：<span class="require" />
                        </th>
                        <td>
                          <input type="text" v-model="user.userIDSecondChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="4" :name="index+1+'番目ユーザーID:第二希望'" validate="required|userId" :id="index+'dealerUserId2'"/>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          第三希望：<span class="require" />
                        </th>
                        <td>
                          <input type="text" v-model="user.userIDThirdChoice" maxlength="20" placeholder="6文字以上20文字以内。英数記号('-','_')のうち2種類を含めてください。" class="4" :name="index+1+'番目ユーザーID:第三希望'" validate="required|userId" :id="index+'dealerUserId3'"/>
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>
                          ※IDは6文字以上20文字以内。英文字・数字・記号のうち2種類を含めてください。大文字・小文字は区別しません。記号は”-”ハイフン又は”_”アンダースコアを使用してください。
                        </td>
                      </tr>
                      <tr>
                        <th>
                          メールアドレス<span class="require" />
                        </th>
                        <td>
                          <input type="text" v-model="user.mail" class="4" :name="index+1+'番目ユーザーメールアドレス'" validate="required|mail"  maxlength="256"/>
                        </td>
                      </tr>
                      <tr>
                        <th></th>
                        <td>※ID登録完了、パスワードの再発行等はご登録いただいたメールアドレス宛てに、電子メールにてお知らせします。</td>
                      </tr>
                    </table>
                  </div>
                </template>
                <div class="margin-top">
                  <b-button style="width:100%;background:#6191eb; color:black;" @click="addUser('userDealerInfoList')">ユーザーを追加する</b-button>
                </div>
                <div class="card-content margin-top">
                  <table>
                      <tr>
                        <th>
                          ■個人情報の管理に関する事項
                        </th>
                        <td></td>
                      </tr>
                      <tr>
                        <td colspan="2" style="padding-left:20px;">
                            申請者は、上記の個人情報がケア　オーケストレーター上で管理されることに同意します。<br>
                            株式会社フィリップス・ジャパンは、当申請書より知り得た個人情報を、ケア　オーケストレーターに関わる運用保守業務以外に使用しません。<br>
                            ID・パスワード忘れに関するお問い合わせは、お電話での回答はできかねますのでご了承ください。<br>
                            異動などの事由により当ユーザーアカウントを使用されなくなった場合には、速やかに弊社営業担当者までお知らせ下さい。<br>
                            また、定期的にユーザーアカウントが使用されているか、確認させていただくことがございます。
                        </td>
                      </tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item :step="isDealer() ? '5' : '4'" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!--　申込み詳細 -->
                <CORegistRequestDetail :institutionApplication="institutionApplication" :mergedUserInfoList="mergedUserInfoList"  />
                <b-button  class="is-primary" style="margin-top:5px;width:250px;" @click="requestCo">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item :step="isDealer() ? '6' : '5'" label="完了" icon="check" :type="{'is-success': true}">
              <div id="item-contens">
                <div class="request-title"><span>ケア オーケストレーターの利用申込みを受け付けました。</span></div>
                <div class="card-content margin-top">
                  <table>
                    <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                    <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                  </table>
                </div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                </div>
              </div>
            </b-step-item>
          </b-steps>
        </div>
      </div>
    </section>
    <b-modal :active.sync="selectIsRegisteredModalActive" has-modal-card :can-cancel="false">
      <selectIsRegisteredModal  v-on:setIsRegistered="storeIsRegistered" v-bind:title="'ケア オーケストレーター 利用状況'"></selectIsRegisteredModal>
    </b-modal>
  </div>
</template>

<script>
import {
  role,
  consentStatement,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import CORegistRequest from "@/components/mock/common/CORegistRequestDetail";
import selectIsRegisteredModal from "@/components/mock/guest/careorchestrator/selectIsRegisteredModal";

// ユーザー情報（医療施設）
// NOTE: userInfoとするとネーミングがバッティングするため、healthCareWorkerと命名しています。
const healthCareWorker = {
  familyName: "",
  firstName: "",
  userClassification: "医療従事者",
  prescriptionSettings: true,
  userIDFirstChoice: "",
  userIDSecondChoice: "",
  userIDThirdChoice: "",
  mail: "",
};
// ユーザー情報（ディーラー）
const userDealerInfo = {
  familyName: "",
  firstName: "",
  userClassification: "ディーラー",
  prescriptionSettings: false,
  userIDFirstChoice: "",
  userIDSecondChoice: "",
  userIDThirdChoice: "",
  mail: "",
};
// 医療機関のみの項目
const institutionItem = {
  careExporter: false
};

export default {
  name: "CORegistRequest",
  methods: {
    Backward: function() {
      // ユーザー情報（ディーラー）の入力をスキップした際に配列を空にするため、前へ操作で入力画面に戻った際に初期化
      if (this.isDealer() && this.activeStep === 4 && !this.userDealerInfoList.length) {
        this.userDealerInfoList.push({ ...userDealerInfo });
      }
      this.activeStep -= 1;
    },
    Forward: function() {
      // バリデーションチェック
      // NOTE: HTML内のclassの値と差異があるため、こちらで+1することで合わせています。
      const elements = document.getElementsByClassName(this.activeStep + 1);
      this.result = this.selfMadeValidation(elements);
      if (this.activeStep === 2) {
        this.CheckedDuplication(this.userInfoList);
        // ユーザー情報（医療施設）における操作可能ユーザーが存在するかの判定
        const isOperable = this.userInfoList.some((user) => {
          return user.prescriptionSettings;
        });
        if (!isOperable) {
          this.result.msg += "少なくとも1ユーザーは操作可を指定してください。\n";
          this.errorFlag = true;
        }
      } else if (this.isDealer() && this.activeStep === 3) {
        this.CheckedDuplication(this.userDealerInfoList);
      }

      if (this.isDealer() && this.activeStep === 3 || !this.isDealer() && this.activeStep === 2) {
        this.merge();
      }

      // ユーザー情報（ディーラー）の入力をスキップするかを確認
      if (this.isDealer() && this.activeStep === 3 && this.result.isError && !this.result.isFormatError) {
        const displayMessage = `ディーラーの情報が入力されていません。\n次へ進みますか？\n\n${this.result.msg}`;
        const replacedDisplayMessage = displayMessage.replace(/\n/g, "<br>");
        this.$dialog.confirm({
          title: "　",
          message: replacedDisplayMessage,
          cancelText: "戻る",
          confirmText: "進む",
          onConfirm: () => {
            this.activeStep += 1;
            this.userDealerInfoList.length = 0;
            this.mergedUserInfoList = [...this.userInfoList];
          },
        });
      } else {
        if (this.result.msg) {
          this.showErrorMessage(this.result.msg);
        } else {
          if (this.activeStep === 2 || this.isDealer() && this.activeStep === 3) {
            this.userID1Element.style["border-color"] = "";
            this.userID2Element.style["border-color"] = "";
            this.userID3Element.style["border-color"] = "";
          }
          this.activeStep += 1;
        }
      }
    },
    // 希望ユーザーIDの重複チェック
    CheckedDuplication: function(arrayList) {
      if (!arrayList) {
        return;
      }

      arrayList.map((user, index) => {
        if (!user.userIDFirstChoice || !user.userIDSecondChoice || !user.userIDThirdChoice) {
          return;
        }

        if (this.activeStep === 2) {
          this.userID1Element = document.getElementById(index + 'userId1');
          this.userID2Element = document.getElementById(index + 'userId2');
          this.userID3Element = document.getElementById(index + 'userId3');
        } else if (this.isDealer() && this.activeStep === 3) {
          this.userID1Element = document.getElementById(index + 'dealerUserId1');
          this.userID2Element = document.getElementById(index + 'dealerUserId2');
          this.userID3Element = document.getElementById(index + 'dealerUserId3');
        }
        if (user.userIDFirstChoice.toUpperCase() === user.userIDSecondChoice.toUpperCase()) {
          // 第一希望と第二希望
          this.result.msg += (index + 1) + "番目の希望ユーザーIDが重複しています。\n";
          this.errorFlag = true;
          this.userID1Element.style["border-color"] = "red";
          this.userID2Element.style["border-color"] = "red";
        }

        if (user.userIDFirstChoice.toUpperCase() === user.userIDThirdChoice.toUpperCase()) {
          // 第一希望と第三希望
          if (!this.errorFlag) {
            this.result.msg += (index + 1) + "番目の希望ユーザーIDが重複しています。\n";
            this.errorFlag = true;
          }
          this.userID1Element.style["border-color"] = "red";
          this.userID3Element.style["border-color"] = "red";
        }

        if (user.userIDSecondChoice.toUpperCase() === user.userIDThirdChoice.toUpperCase()) {
          // 第二希望と第三希望
          if (!this.errorFlag) {
            this.result.msg += (index + 1) + "番目の希望ユーザーIDが重複しています。\n";
            this.errorFlag = true;
          }
          this.userID2Element.style["border-color"] = "red";
          this.userID3Element.style["border-color"] = "red";
        }
        if (this.errorFlag) {
          this.errorFlag = !this.errorFlag;
        }
      });
    },
    merge: function() {
      if (this.isDealer()) {
        this.mergedUserInfoList = [...this.userInfoList, ...this.userDealerInfoList];
      } else {
        this.mergedUserInfoList = [...this.userInfoList];
      }
    },
    requestCo: function() {
      this.$dialog.confirm({
        title: "申込み確認",
        message: "ケア オーケストレーターの利用を申込みます。<br/>申込み内容が正しいことを確認して「OK」ボタンを押してください。",
        cancelText: "修正する",
        onConfirm: async () => {
          this.completeFlg = false;
          var executeApi = this.setCoApplicationPOST;
          var successCallBack = this.setCoApplicationPOSTSuccess;
          var errorCallBack = this.setCoApplicationPOSTError;
          // WebAPI Call
          await this.apiCall(executeApi, successCallBack, errorCallBack)
          if(this.completeFlg){
            this.jumpToTop();
            this.activeStep += 1;
          }
        }
      })
    },
    setCoApplicationPOST: function(client) {
      this.reqParams.institutionApplication = this.institutionApplication;
      if (this.isDealer()) {
        this.reqParams.userInfoList = [...this.userInfoList, ...this.userDealerInfoList];
      } else {
        this.reqParams.userInfoList = this.userInfoList;
      }
      const obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.belongsId = this.belongsId;
      return client.apis.externalCO.setCoApplicationPOST({
        body: obj
      });
    },
    setCoApplicationPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.coInstitutionId = result.obj.coInstitutionId
      if(this.userInfo.coType == 1){
        // ディーラーで無い場合は、ケアオケ申請済みの状態に更新
        this.userInfo.coType = 2
        this.userInfo.coCertificationFlag = this.institutionApplication.clientAuthentication;
        this.userInfo.coInstitutionId = this.coInstitutionId;
        this.userInfo.CoApplicationReceiptNumber = this.receiptNumber.split(",")[0]
        sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo));
      }
      this.completeFlg = true;
    },
    setCoApplicationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    back: function() {
      this.$router.go(-1);
    },
    goHome: function() {
      this.back();
    },
    addUser: function(listType) {
      if (listType === "userInfoList") {
        this.userInfoList.push(this.isDealer() ? { ...healthCareWorker } : { ...healthCareWorker, ...institutionItem });
      } else {
        this.userDealerInfoList.push({ ...userDealerInfo });
      }
    },
    deleteUser: function(listType, index) {
      if (listType === "userInfoList") {
        this.userInfoList.splice(index, 1);
      } else {
        this.userDealerInfoList.splice(index, 1);
      }
    },
    isDealer: function(){
      return this.roleId == this.role.role_dealer;
    },
    download: function() {
      this.$store.dispatch("downloadConsentStatement", {
          type: this.consentStatement.care_orchestrator,
          uid: this.userInfo.id
      }).then(result => {
          if(!result.status || result.status != 200){
              if(result.obj){
                  this.showErrorMessage(result.obj.message);
              } else {
                  this.showErrorMessage(result.message);
              }
          }
      }).catch(error => {
          this.showErrorMessage(error);
      });
    },
    getAgreementStr: async function() {
      const executeApi = this.getConsentStatementPOST;
      const successCallBack = this.getConsentStatementPOSTSuccess;
      const errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      return client.apis.apiCommon.getConsentStatementPOST({
        body: {
          type: this.consentStatement.care_orchestrator,
        }
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreementStr = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreementStr = "利用規約が登録されていません。";
      }

    },
    getConsentStatementPOSTError: function() {
      this.agreementStr == "利用規約を取得できませんでした。";
    },
    storeIsRegistered: function(isRegistered) {
      this.isRegistered = isRegistered;
    },
  },
  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var branchList = this.getBranchOfficeMaster();
    branchList.unshift({});
    const { role_dealer } = role;
    const { roleId, belongsId, medicalInstitutionName, departmentName, postcode, prefecture, city, address, building, phoneNumber } = userInfo;
    return {
      consentStatement,
      userInfo,
      role,
      roleId,
      belongsId,
      branchList,
      reqParams: {},
      institutionApplication: {
        hospitalName: roleId != role_dealer ? medicalInstitutionName : "",
        division: roleId != role_dealer ? departmentName : "",
        office: "",
        zip: roleId != role_dealer ? postcode : "",
        prefecture: roleId != role_dealer ? prefecture : "",
        city: roleId != role_dealer ? city : "",
        address1: roleId != role_dealer ? address : "",
        address2: roleId != role_dealer ? building : "",
        phoneNumber: roleId != role_dealer ? phoneNumber : "",
        clientAuthentication: false,
        crossReference: true,
        biko: "",
      },
      userInfoList: [],
      userDealerInfoList: [],
      mergedUserInfoList: [],
      isChecked: false,
      agreementStr: "",
      activeStep: 0,
      isHospitalAgree: userInfo.roleId != role.role_dealer,
      requestDate:"",
      receiptNumber:"",
      completeFlg:false,
      canAgree:false,
      invalidPostcode: false,
      invalidPhoneNumber: false,
      selectIsRegisteredModalActive: userInfo.roleId != role.role_dealer,
      isRegistered:"未登録",
      userID1Element: "",
      userID2Element: "",
      userID3Element: "",
      errorFlag: false,
      result: {},
    };
  },
  async mounted() {
    // 同意文取得
    await this.getAgreementStr();
    this.userInfoList.push(this.isDealer() ? { ...healthCareWorker } : { ...healthCareWorker, ...institutionItem });
    this.userDealerInfoList.push({ ...userDealerInfo });
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  components: {
    selectIsRegisteredModal:selectIsRegisteredModal,
    CORegistRequestDetail: CORegistRequest
  },
  watch: {
    "institutionApplication.zip"(newValue) {
      this.invalidPostcode = isNaN(Number(newValue));
    },
    "institutionApplication.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    }
  }
};
</script>

<style lang="scss" scoped>
.urgency_caution {
  color: red;
}
.dealer_request_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.under_line {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/CORegistRequest.vue